/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetBeepers200Response
 */
export interface GetBeepers200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBeepers200Response
     */
    metadata: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof GetBeepers200Response
     */
    beepers: Array<any>;
}

/**
 * Check if a given object implements the GetBeepers200Response interface.
 */
export function instanceOfGetBeepers200Response(value: object): value is GetBeepers200Response {
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    if (!('beepers' in value) || value['beepers'] === undefined) return false;
    return true;
}

export function GetBeepers200ResponseFromJSON(json: any): GetBeepers200Response {
    return GetBeepers200ResponseFromJSONTyped(json, false);
}

export function GetBeepers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBeepers200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'metadata': json['metadata'],
        'beepers': json['beepers'],
    };
}

export function GetBeepers200ResponseToJSON(json: any): GetBeepers200Response {
    return GetBeepers200ResponseToJSONTyped(json, false);
}

export function GetBeepers200ResponseToJSONTyped(value?: GetBeepers200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'metadata': value['metadata'],
        'beepers': value['beepers'],
    };
}

